import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ScanRunView, SiteComponentView, SiteDetail } from '@ametica/shared';
import { api } from './client';
import { SITES_KEY } from './sites';

export function useSiteDetail(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id], queryFn: () => api<SiteDetail>(`/sites/${id}`) });
}

export function useSiteComponents(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id, 'components'], queryFn: () => api<SiteComponentView[]>(`/sites/${id}/components`) });
}

export function useSiteScans(id: string) {
  return useQuery({ queryKey: [...SITES_KEY, id, 'scans'], queryFn: () => api<ScanRunView[]>(`/sites/${id}/scans`) });
}

/** Ručný ScanRun — zber inventára + matching. Nemíňa kvótu Wordfence. 409 = sken tejto stránky práve beží. */
export function useScanSite(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api<ScanRunView>(`/sites/${id}/scan`, { method: 'POST' }),
    onSettled: () => {
      qc.invalidateQueries({ queryKey: SITES_KEY });
      qc.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}
